import { render, staticRenderFns } from "./overage-requests.vue?vue&type=template&id=63724c58&scoped=true&"
import script from "./overage-requests.vue?vue&type=script&lang=js&"
export * from "./overage-requests.vue?vue&type=script&lang=js&"
import style0 from "./overage-requests.vue?vue&type=style&index=0&id=63724c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63724c58",
  null
  
)

export default component.exports